import { render } from "./close-square-icon.vue?vue&type=template&id=c66205e4"
import script from "./close-square-icon.vue?vue&type=script&lang=js"
export * from "./close-square-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__